(function () {
  function initSnow() {
    if (document.getElementById("snow-canvas")) return;

    const canvas = document.createElement("canvas");
    canvas.id = "snow-canvas";
    canvas.style.cssText = `
      position: fixed;
      top: 0; left: 0;
      width: 100vw; height: 100vh;
      pointer-events: none;  /* taps go through */
      z-index: 9999;
    `;
    document.body.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    let w, h, flakes = [];
    let flakeCount = 0;

    function resize() {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      setFlakeCount();     // 👈 adjust for mobile/desktop
      makeFlakes();
    }
    window.addEventListener("resize", resize);

    function setFlakeCount() {
      // ✅ Mobile detection by width
      if (window.innerWidth <= 768) {
        flakeCount = 25;   // mobile flakes
      } else {
        flakeCount = 60;   // desktop flakes
      }
    }

    function drawFlake(size) {
      ctx.lineWidth = Math.max(1, size / 12);
      ctx.strokeStyle = "rgba(255,255,255,0.95)";
      ctx.shadowColor = "rgba(255,255,255,0.6)";
      ctx.shadowBlur = window.innerWidth <= 768 ? 0 : 3; // ✅ less GPU on mobile

      const arms = 6;
      for (let i = 0; i < arms; i++) {
        ctx.rotate((Math.PI * 2) / arms);
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, size);

        ctx.moveTo(0, size * 0.55);
        ctx.lineTo(size * 0.18, size * 0.7);
        ctx.moveTo(0, size * 0.55);
        ctx.lineTo(-size * 0.18, size * 0.7);

        ctx.stroke();
      }
    }

    function makeFlakes() {
      flakes = Array.from({ length: flakeCount }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        size: Math.random() * 8 + 6,
        speed: Math.random() * 2 + 1.2,
        drift: Math.random() * 0.8 - 0.4,
        rot: Math.random() * 360,
        rotSpeed: Math.random() * 2 - 1
      }));
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);

      for (let f of flakes) {
        ctx.save();
        ctx.translate(f.x, f.y);
        ctx.rotate((f.rot * Math.PI) / 180);
        drawFlake(f.size);
        ctx.restore();
      }

      update();
    }

    function update() {
      for (let f of flakes) {
        f.y += f.speed;
        f.x += f.drift;
        f.rot += f.rotSpeed;

        if (f.y > h + 20) { f.y = -20; f.x = Math.random() * w; }
        if (f.x > w + 20) f.x = -20;
        if (f.x < -20) f.x = w + 20;
      }
      requestAnimationFrame(draw);
    }

    resize();  // initial setup
    draw();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSnow);
  } else {
    initSnow();
  }
})();
